<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 6579 6579"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="3290" cy="3290" r="3290"/>
  <path class="fil1" d="M3569 4101l0 -3050c0,-158 -133,-285 -279,-285 -147,0 -280,127 -280,285l0 3080c-382,136 -656,500 -656,929 0,545 442,987 987,987 545,0 986,-442 986,-987 0,-466 -323,-856 -758,-959z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Thermometer',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1}
.fil1 {fill:#FEFEFE;fill-rule:nonzero}
</style>
